import React from 'react'

export default function (props) {
  const { className, onClick } = props

  return (
    <div className={className ? className : ''} onClick={onClick}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          d="M1 12c0 6.075 4.925 11 11 11s11-4.925 11-11S18.075 1 12 1C7.563 1 4 4 2 7.5M1 1v7h7m8 9l-4-4V6"
        />
      </svg>
    </div>
  )
}
